<script lang="ts">
    import { apiBaseOverride } from "../../store"
    import LinkList from "../LinkList.svelte"
    import MedialibImage from "../MedialibImage.svelte"

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase

    export let card: BlockContentCard
    export let reverse: boolean = false
</script>

<!-- is admin view or not hidden -->
{#if apiBase || !card.hide}
    <div class="col-grid grid-bleed" class:hidden="{!!card.hide}">
        <article class="col-12 solution-row">
            <div class="grid grid-bleed" class:direction-row-reverse="{reverse}">
                <!-- hier .direction-row-reverse setzen, wenn das Bild rechts und der Text links aufscheinen soll, auswählbar machen (Dropdown) -->
                <div class="col-lg-6 col-12">
                    {#if card.image}
                        <div class="background-image">
                            <figure>
                                <MedialibImage id="{card.image}" />
                            </figure>
                        </div>
                    {/if}
                </div>
                <div class="col-lg-6 col-12">
                    <div class="content tp-xl bp-xl hp-xl white-bg">
                        <div class="icon">
                            {#if card.iconClass}
                                <span class="si-{card.iconClass}"></span>
                                <!-- Icon, das sich aus "Kategorie" zusammensetzt -->
                            {:else if card.icon}
                                <figure>
                                    <MedialibImage id="{card.icon}" />
                                </figure>
                            {/if}
                        </div>
                        <div class="headline tp-m">
                            <h3>{card.title}</h3>
                        </div>
                        <div class="copy tp-l bp-l">
                            {@html card.text}
                        </div>
                        {#if card.links?.length}
                            <div class="button-wrap gap-m">
                                <!-- Buttons sitzen im Wrapper, sollten vermutlich auch flexibel / repeatable sein, mal nur einen, mal zwei, mal keiner -->
                                <LinkList links="{card.links}" />
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        </article>
    </div>
{/if}

<style lang="less">
    .hidden {
        opacity: 0.5 !important;
        filter: grayscale(100%);
    }
</style>
